module.exports = __webpack_public_path__ + "static/media/import_opt_person.1febd527.xlsx";